import {Injectable} from "@angular/core";
import {apiconfig} from "../app/api.config";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "./AuthService";
import {Observable} from "rxjs";
import {PhotoTag} from "../model/PhotoTag";
import {TaggedPhoto} from "../model/TaggedPhoto";
import {MissionReportPhoto} from "../model/MissionReportPhoto";

@Injectable()
export class PhotoService {

  apiConfig: any = apiconfig;

  constructor(protected http: HttpClient, public authService: AuthService) {

  }

  /**
   * Get photo tag from a given operation
   * @param id
   */
  findNbPictures(photoTags: PhotoTag[], orderId: number): Observable<TaggedPhoto[]> {

    let photos: TaggedPhoto[] = new Array();

    let h = this.authService.getHttpAuth();

    return Observable.create(obs => {

      for (let tag in photoTags) {

        let photoTag: PhotoTag = photoTags[tag];

        this.http
          .get(this.apiConfig.API_URL + '/operation/pcheck/photos/mission/' + orderId + '/tag/' + photoTag.id, {headers: h})
          .subscribe(response => {
              if (response) {
                photos.push(TaggedPhoto.fromJson(response));

              }
            },
            (error) => {
            });

        obs.next(photos);

      }

      obs.complete();

    });
  }

  /**
   * Get photo tag from a given operation
   *
   * @param id
   */
  findNbPicturesWithPromise(photoTags: PhotoTag[], orderId: number): Promise<TaggedPhoto[]> {

    let taggedPhotos: TaggedPhoto[] = new Array();

    let h = this.authService.getHttpAuth();

    return new Promise<TaggedPhoto[]>(
      (resolve, reject) => {

        let nbRequest = 0;
        for (let tag = 0; tag < photoTags.length; tag++) {

          let photoTag: PhotoTag = photoTags[tag];

          this.http
            .get(this.apiConfig.API_URL + '/operation/pcheck/photos/mission/' + orderId + '/tag/' + photoTag.id, {headers: h})
            .toPromise()
            .then(resp => {
              nbRequest++;

              let taggedPhoto: TaggedPhoto = TaggedPhoto.fromJson(resp);
              taggedPhoto.name = photoTag.name;
              taggedPhotos.push(taggedPhoto);

              // termine la promise quand toutes les requestes sont passes
              if (nbRequest === photoTags.length)
                resolve(taggedPhotos);

            })
        }

      });
  }

  loadPhotos(id: number): Promise<any> {

    return new Promise(
      (resolve, reject) => {

        let h = this.authService.getHttpAuth();

        // build query parameters
        let httpParams = new HttpParams();

        httpParams = httpParams.append("id", String(id));
        httpParams = httpParams.append("thumb", "true");

        this.http
          .get(this.apiConfig.API_URL + '/operational/presencecheck/photo', {
            headers: h,
            responseType: 'blob',
            params: httpParams
          })
          .toPromise()
          .then(imageAsBlob => {
              if (imageAsBlob) {

                let image: any;
                // read image from blob
                let reader = new FileReader();
                reader.addEventListener("load", () => {
                  image = reader.result;
                  resolve(image);
                  // renvoie une image base64 format eg : "data:image/jpeg;base64,/9j/4fLKRXhpZgAAT......
                }, false);

                reader.readAsDataURL(imageAsBlob);

              }
            },
            (error) => {
              console.log(error);
            });

      });


  }

  loadStoreAuditedPhotos(id: number): Promise<any> {

    return new Promise(
      (resolve, reject) => {

        let h = this.authService.getHttpAuth();

        this.http
          .get(this.apiConfig.API_URL + '/store-audit/photo' + id + '/thumb/' + 1, {
            headers: h,
            responseType: 'blob'
          })
          .toPromise()
          .then(imageAsBlob => {
              if (imageAsBlob) {

                let image: any;
                // read image from blob
                let reader = new FileReader();
                reader.addEventListener("load", () => {
                  image = reader.result;
                  resolve(image);
                  // renvoie une image base64 format eg : "data:image/jpeg;base64,/9j/4fLKRXhpZgAAT......
                }, false);

                reader.readAsDataURL(imageAsBlob);

              }
            },
            (error) => {
              console.log(error);
            });

      });

  }

  /**
   *
   * @param from
   * @param to
   * @param operation
   * @param retailer
   * @param mission
   */
  searchPhoto(from: number, to: number, operation: number, retailer: number, mission: number[]): Promise<MissionReportPhoto[]> {

    let missionPhotoReport: MissionReportPhoto[] = [];


    // build query parameters
    let httpParams = new HttpParams();

    httpParams = httpParams.append("from", from != null ? String(from) : "");
    httpParams = httpParams.append("to", to != null ? String(to) : "");
    httpParams = httpParams.append("op", operation != null ? String(operation) : "");
    httpParams = httpParams.append("ret", retailer != null ? String(retailer) : "");
    if (mission != null)
      mission.forEach(m => {
        httpParams = httpParams.append("mission", '' + m);
      });


    let h = this.authService.getHttpAuth();

    return this.http.get<MissionReportPhoto[]>(this.apiConfig.API_URL + '/order/mission-report-photo', {
      headers: h,
      params: httpParams
    }).toPromise();


  }


}



// WEBPACK FOOTER //
// ./src/services/PhotoService.ts